module.exports = __webpack_public_path__ + "img/page_load_failed.f1d8dd06.svg";